import { useState, useEffect, useMemo } from "react";
import { getEstDate } from "../../../utils/commonFunctions";

interface TimeCounter {
  seconds: number;
  minutes: number;
  hours: number;
  days: number;
}

const useTimeCounter = (endDate: string, endTime: string, setShowAnnouncement?: () => void): TimeCounter => {
  const [timeCounter, setTimeCounter] = useState({
    seconds: 0,
    minutes: 0,
    hours: 0,
    days: 0,
  });

  // Future timestamp
  const futureTimestamp = useMemo(() => {
    return new Date(`${endDate} ${endTime}`).getTime();
  }, [endDate, endTime]);

  const getTimeSet = (interval: any) => {
    const currentTimestamp = getEstDate().getTime();
    const timeDifference = futureTimestamp - currentTimestamp;
    if (timeDifference <= 0) {
      setShowAnnouncement?.();
      if (interval) clearInterval(interval);
      return;
    }
    setTimeCounter({
      days: Math.floor(timeDifference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      minutes: Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((timeDifference % (1000 * 60)) / 1000),
    });
  };

  useEffect(() => {
    getTimeSet(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      getTimeSet(interval);
    }, 1000);
    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [futureTimestamp, setShowAnnouncement]);
  return { seconds: timeCounter.seconds, minutes: timeCounter.minutes, hours: timeCounter.hours, days: timeCounter.days };
};

export default useTimeCounter;
